import persoAccomplishmentImage from '../assets/needs/perso/accomplishment.jpg';
import persoEternityImage from '../assets/needs/perso/eternity.jpg';
import persoHorizontalBelongingImage from '../assets/needs/perso/horizontal_belonging.jpg';
import persoPhysiologicalImage from '../assets/needs/perso/physiological.jpg';
import persoPhysiologicalPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n1_physiologiques.svg';
import persoSecurityPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n2_securite.svg';
import persoHorizontalBelongingPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n3_appartenance-horizontale.svg';
import persoVerticalBelongingPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n4_appartenance-verticale.svg';
import persoAccomplishmentPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n5_accomplissement.svg';
import persoSelfRealizationPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n6_realisation-de-soi.svg';
import persoSpiritualityPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n7_spiritualite.svg';
import persoEternityPyramid from '../assets/needs/perso/Pyramide-besoins_perso_n8_eternite.svg';
import persoSecurityImage from '../assets/needs/perso/security.jpg';
import persoSelfRealizationImage from '../assets/needs/perso/self_realization.jpg';
import persoSpiritualityImage from '../assets/needs/perso/spirituality.jpg';
import persoVerticalBelongingImage from '../assets/needs/perso/vertical_belonging.jpg';
import proAccomplishmentImage from '../assets/needs/pro/accomplishment.jpg';
import proEternityImage from '../assets/needs/pro/eternity.jpg';
import proHorizontalBelongingImage from '../assets/needs/pro/horizontal_belonging.jpg';
import proPhysiologicalImage from '../assets/needs/pro/physiological.jpg';
import proPhysiologicalPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n1_physiologiques.svg';
import proSecurityPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n2_securite.svg';
import proHorizontalBelongingPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n3_appartenance-horizontale.svg';
import proVerticalBelongingPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n4_appartenance-verticale.svg';
import proAccomplishmentPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n5_accomplissement.svg';
import proSelfRealizationPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n6_realisation-de-soi.svg';
import proSpiritualityPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n7_spiritualite.svg';
import proEternityPyramid from '../assets/needs/pro/Pyramide-besoins_pro_n8_eternite.svg';
import proSecurityImage from '../assets/needs/pro/security.jpg';
import proSelfRealizationImage from '../assets/needs/pro/self_realization.jpg';
import proSpiritualityImage from '../assets/needs/pro/spirituality.jpg';
import proVerticalBelongingImage from '../assets/needs/pro/vertical_belonging.jpg';

export const needsRankColors = ['#071B45', '#212E57', '#4D597A'];

export const needsAssets: Record<string, { image: string; pyramid: string }> = {
  physiological_pro: { image: proPhysiologicalImage, pyramid: proPhysiologicalPyramid },
  security_pro: { image: proSecurityImage, pyramid: proSecurityPyramid },
  horizontal_belonging_pro: {
    image: proHorizontalBelongingImage,
    pyramid: proHorizontalBelongingPyramid,
  },
  vertical_belonging_pro: {
    image: proVerticalBelongingImage,
    pyramid: proVerticalBelongingPyramid,
  },
  accomplishment_pro: { image: proAccomplishmentImage, pyramid: proAccomplishmentPyramid },
  self_realization_pro: { image: proSelfRealizationImage, pyramid: proSelfRealizationPyramid },
  spirituality_pro: { image: proSpiritualityImage, pyramid: proSpiritualityPyramid },
  eternity_pro: { image: proEternityImage, pyramid: proEternityPyramid },
  physiological_perso: { image: persoPhysiologicalImage, pyramid: persoPhysiologicalPyramid },
  security_perso: { image: persoSecurityImage, pyramid: persoSecurityPyramid },
  horizontal_belonging_perso: {
    image: persoHorizontalBelongingImage,
    pyramid: persoHorizontalBelongingPyramid,
  },
  vertical_belonging_perso: {
    image: persoVerticalBelongingImage,
    pyramid: persoVerticalBelongingPyramid,
  },
  accomplishment_perso: { image: persoAccomplishmentImage, pyramid: persoAccomplishmentPyramid },
  self_realization_perso: {
    image: persoSelfRealizationImage,
    pyramid: persoSelfRealizationPyramid,
  },
  spirituality_perso: { image: persoSpiritualityImage, pyramid: persoSpiritualityPyramid },
  eternity_perso: { image: persoEternityImage, pyramid: persoEternityPyramid },
};
